import type { ExpandedState } from "@tanstack/react-table";

import { debounce } from "lodash";
import { create } from "zustand";

type UIState = {
  isFilterPanelVisible: boolean;
  toggleFilterPanel: () => void;
  userDropdownOpen: boolean;
  toggleUserDropdown: () => void;
  density: string;
  setDensity: (newDensity: string) => void;
  expandedRows: ExpandedState;
  setExpandedRows: (
    updater: ExpandedState | ((prevState: ExpandedState) => ExpandedState)
  ) => void;
  collapseAllRows: () => void;
  isTunecore: boolean;
  setIsTunecore: (isTunecore: boolean) => void;
};

export const useUIStateStore = create<UIState>(set => ({
  isFilterPanelVisible: true,
  toggleFilterPanel: () => set(state => ({ isFilterPanelVisible: !state.isFilterPanelVisible })),

  userDropdownOpen: false,
  toggleUserDropdown: () =>
    set(state => ({ userDropdownOpen: !state.userDropdownOpen })),

  density: localStorage.getItem("tableDensity") ?? "condensed",
  setDensity: debounce((newDensity: string) => {
    set({ density: newDensity });
    localStorage.setItem("tableDensity", newDensity);
  }, 100),

  expandedRows: {},
  setExpandedRows: updater =>
    set((state) => {
      const newExpandedRows
        = typeof updater === "function" ? updater(state.expandedRows) : updater;
      return { expandedRows: newExpandedRows };
    }),
  collapseAllRows: () => {
    set({ expandedRows: {} });
  },

  isTunecore: false,
  setIsTunecore: (isTunecore: boolean) => set({ isTunecore }),
}));
